/* eslint-disable no-nested-ternary */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import EyesClosedIcon from '../Icons/EyesClosedIcon'
import EyesOpenIcon from '../Icons/EyesOpenIcon'
import InputErrorIcon from '../Icons/InputErrorIcon'
import Text from '../Text/Text'
import styles from './textField.module.scss'

class PasswordField extends Component {
  constructor(props) {
    super(props)

    this.state = {
      visible: false,
      isActive: false
    }

    this.handleVisible = this.handleVisible.bind(this)
  }

  handleVisible() {
    const { visible } = this.state

    this.setState({ visible: !visible })
  }

  render() {
    const {
      field: { name, id, onChange, value } = {},
      form: { errors = {}, values } = {},
      type,
      full,
      margin,
      variation,
      showRules,
      placeholder,
      label
    } = this.props

    const hasError = Object.prototype.hasOwnProperty.call(errors, name)

    const { visible, isActive } = this.state

    const textFieldClass = classNames(styles.field, {
      [styles.full]: full,
      [styles[variation]]: variation,
      [styles.hasError]: !showRules && hasError
    })

    const fieldType = !visible ? type : 'text'

    const textFieldStyle = {}

    if (margin) textFieldStyle.margin = margin

    const rules = errors[name]?.errors

    const passwordErrors = { ...rules }

    const {
      minimumEight,
      uppercaseLetter,
      lowercaseLetter,
      oneSymbol,
      oneNumber
    } = passwordErrors

    const openedEye = (
      <button type="button" onClick={this.handleVisible}>
        <EyesOpenIcon />
      </button>
    )

    const closedEye = (
      <button type="button" onClick={this.handleVisible}>
        <EyesClosedIcon />
      </button>
    )

    const handleChange = (e) => {
      const text = e.target.value
      onChange(e)

      if (text !== '') {
        this.setState({ isActive: true })
      } else {
        this.setState({ isActive: false })
      }
    }

    return (
      <div className={textFieldClass} style={textFieldStyle}>
        <div className={styles.containerInput}>
          <input
            type={fieldType}
            onChange={handleChange}
            value={value}
            name={name}
            id={id}
            autoComplete="off"
            placeholder={placeholder}
          />
          <div className={styles.iconStatus}>
            <div className={styles.hasErrorIcon}>
              <InputErrorIcon />
            </div>
            {visible ? openedEye : closedEye}
          </div>
          <label
            className={isActive ? styles.labelActive : styles.labelNotActive}
          >
            {label}
          </label>
        </div>

        {showRules && (
          <div className={styles.error}>
            <Text
              font="custom"
              size="xxs"
              color={
                !values[name] ? 'gray' : minimumEight ? 'gray' : 'quaternary'
              }
              variation="dark"
              value="Minimo 8 caracteres"
            />
            <Text
              font="custom"
              size="xxs"
              color={
                !values[name] ? 'gray' : uppercaseLetter ? 'gray' : 'quaternary'
              }
              variation="dark"
              value="Pelo menos 1 letra maiúscula"
            />
            <Text
              font="custom"
              size="xxs"
              color={
                !values[name] ? 'gray' : lowercaseLetter ? 'gray' : 'quaternary'
              }
              variation="dark"
              value="Pelo menos 1 letra minúscula"
            />
            <Text
              font="custom"
              size="xxs"
              color={!values[name] ? 'gray' : oneSymbol ? 'gray' : 'quaternary'}
              variation="dark"
              value="Pelo menos 1 símbolo"
            />
            <Text
              font="custom"
              size="xxs"
              color={!values[name] ? 'gray' : oneNumber ? 'gray' : 'quaternary'}
              variation="dark"
              value="Pelo menos 1 número"
            />
          </div>
        )}

        {!showRules && hasError && (
          <div className={styles.error}>
            <Text font="custom" size="xxs" color="error" value={errors[name]} />
          </div>
        )}
      </div>
    )
  }
}

PasswordField.defaultProps = {
  field: undefined,
  form: undefined,
  type: undefined,
  full: false,
  margin: null,
  variation: null,
  showRules: null,
  placeholder: null,
  label: null
}

PasswordField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  form: PropTypes.shape({
    values: PropTypes.shape({}),
    errors: PropTypes.shape({})
  }),
  type: PropTypes.string,
  full: PropTypes.bool,
  margin: PropTypes.bool,
  variation: PropTypes.string,
  showRules: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string
}

export default PasswordField
